<template>
    <section class="block blog-cat">
        <div class="wrap">
            <div class="blog-toolbar">
                <div class="blog-filters">
                    <button type="button" :class="{ active: activeCategory === null }" @click="selectCategory(null)">
                        Todos
                    </button>
                    <button type="button" v-for="category in categories" :key="category.id"
                        :class="{ active: activeCategory === category.id }" @click="selectCategory(category.id)">
                        {{ category.name }}
                    </button>
                </div>
                <Pagination v-model="filters" :meta="meta" />
            </div>

            <div v-if="status.get" class="blog-cat-grid">
                <div v-for="n in skeletonCount" :key="'sk' + n" class="post post--sk" aria-hidden="true">
                    <div class="p-img rb-sk"></div>
                    <div class="rb-sk rb-sk-line rb-sk-line--sm" style="width:30%"></div>
                    <div class="rb-sk rb-sk-line" style="width:90%"></div>
                    <div class="rb-sk rb-sk-line rb-sk-line--sm" style="width:70%"></div>
                </div>
            </div>
            <BlogNotes v-else :notes="posts" />

            <div class="blog-empty" :class="{ show: !status.get && posts.length === 0 }">
                No hay artículos en esta categoría todavía.
            </div>

            <Pagination v-model="filters" :meta="meta" class="pagination-bottom" />
        </div>
    </section>
</template>
<script>
import BlogNotes from './BlogNotes.vue';
import Pagination from './Pagination.vue';

export default {
    inject: ['axios', 'locale', 'tag'],
    components: { BlogNotes, Pagination },
    data() {
        return {
            posts: [],
            categories: [],
            activeCategory: null,
            meta: {},
            status: { get: false },
            filters: {
                page_size: 9,
                page: 1,
                locale: this.locale,
                include: 'banner,thumbnail,categories',
                'filters[tags]': this.tag,
                'filters[categories]': null
            }
        }
    },
    computed: {
        skeletonCount() {
            return Number(this.filters.page_size) || 9
        }
    },
    watch: {
        filters: {
            handler() { this.getPosts() },
            deep: true,
            immediate: true
        }
    },
    methods: {
        getPosts() {
            this.status.get = true;
            this.axios.get('/posts', { params: this.removeNulls(this.filters) }).then(response => {
                this.posts = response.data.data;
                this.meta = response.data.meta || {};
                this.collectCategories(response.data.data);
            }).catch((e) => {
                console.warn(e);
            }).finally(() => {
                this.status.get = false;
            });
        },

        collectCategories(posts) {
            if (this.categories.length) return;
            const seen = new Map();
            (posts || []).forEach(post => {
                (post.categories || []).forEach(cat => {
                    const id = cat.id || cat._id;
                    if (id && !seen.has(id)) seen.set(id, { id, name: cat.name });
                });
            });
            this.categories = Array.from(seen.values());
        },

        selectCategory(id) {
            this.activeCategory = id;
            this.filters['filters[categories]'] = id;
            this.filters.page = 1;
        },

        removeNulls(obj) {
            return Object.fromEntries(
                Object.entries(obj).filter(([_, value]) => value !== null && value !== undefined)
            );
        }
    }
}
</script>

<style>
/* Skeleton loaders del catálogo de blog (mientras carga la API) */
.post--sk{cursor:default;pointer-events:none;}
.rb-sk{position:relative;overflow:hidden;background:#ece6e2;border-radius:8px;}
.rb-sk::after{content:"";position:absolute;inset:0;transform:translateX(-100%);background:linear-gradient(90deg,transparent,rgba(255,255,255,.65),transparent);animation:rbSkShimmer 1.3s ease-in-out infinite;}
.post--sk .p-img.rb-sk{width:100%;}
.rb-sk-line{height:22px;margin-top:12px;border-radius:6px;}
.rb-sk-line--sm{height:15px;margin-top:10px;}
@keyframes rbSkShimmer{to{transform:translateX(100%);}}
@media (prefers-reduced-motion:reduce){.rb-sk::after{animation:none;}}
</style>
